import React, { useEffect, useRef, useState } from 'react';
import { hideLoading, showLoading } from "@/actions/loaderAction";
import InputField from '@/components/InputField';
import DropDown from '@/components/DropDown';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { default as ReactSelect, components } from "react-select";
import CreatableSelect from "react-select/creatable";
import ButtonAdminpanel from '@/components/ButtonAdminpanel';
import Choosefile from '@/components/Choosefile';
import { countryList } from "@/actions/countryAction";
import { cityMemberList } from "@/actions/cityAction";
import { citySearchMemberList } from "@/actions/citySearchAction";
import { connect } from "react-redux";
import { isEmpty, isString, map, replace, size, trim } from "lodash";
import { updateSupplierCompanyAction, removeSupplierLogo } from "@/actions/stepperAction";
import defaultValues from '@/constant/defaultValues';
import uploadPhotos from "@/images/Company-logo.svg";
import SmallPopup from "@/components/SmallPopup";
import { deleteCertificate } from "@/actions/certificateAction";
import errorMessages from '@/constant/errorMessages';
import regExpressions from "@/constant/regExpressions";
import pdf from "@/images/sidebarImages/pdf_icon.svg";
import MediumPopup from "@/components/MediumPopup";
import ScreenLoaderHome from "@/components/common/ScreenLoaderHome";



const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
const FILE_SIZE_ERROR_MSG = "The file must be less than or equal to 2 MB";
const ALLOWED_CERTIFICATE_TYPES = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];
const ALLOWED_LOGO_TYPES = ["image/jpeg", "image/png", "image/jpg"];

const PINCODE_MAX_LENGTH = 10;
const ADDRESS1_MAX_LENGTH = 255;


const WEBSITE_REGEXP = regExpressions.website_url;
const DESIGNATION_REGEXP =regExpressions.designation;


const getPreviewSrc = (value) => {
  if (!value) return null;
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    if (typeof value.src === "string") return value.src;
    try {
      return URL.createObjectURL(value);
    } catch (err) {
      console.warn("Unable to generate preview URL for uploaded file", err);
      return null;
    }
  }
  return null;
};

const isNewFileValue = (value) => {
  if (!value) return false;
  if (typeof value !== "object") return false;
  // Duck-type instead of `instanceof File` (safer across realms/iframes).
  return typeof value.name === "string" && typeof value.size === "number" && typeof value.type === "string";
};

const isPdfValue = (value) => {
  if (!value) return false;
  if (typeof value === "string") return value.toLowerCase().endsWith(".pdf");
  if (typeof value === "object") {
    if (typeof value.type === "string") return value.type === "application/pdf";
    if (typeof value.name === "string") return value.name.toLowerCase().endsWith(".pdf");
    if (typeof value.src === "string") return value.src.toLowerCase().endsWith(".pdf");
  }
  return false;
};

const BasicDetails = (props) => {

  const { IMAGE_PATH } = defaultValues;
  const PATH = IMAGE_PATH.BASE_URL;

  const [member_supplier_id, setSupplierMemberID] = useState(null);

  const [formData, setFormData] = useState({
    salutation: "",
    first_name: "",
    last_name: "",
    company_name: "",
    website: "",
    designation: "",
    establish_date: "",
    country_id: "",
    cities_id: "",
    mobile: "",
    phone: "",
    established_year: "",
    isNewVal: false,
    target_country: "",
    company_logo: "",
    business_certificate: "",
  });

  const [inputValue, setInputValue] = useState('');

  const [phoneValue, setPhoneValue] = useState("");

  const handlePhoneChange = (value) => {
    setPhoneValue(value);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        phone: value
      }
    });
  };

  const [mobileValue, setMobileValue] = useState("");

  const handleMobileChange = (value) => {
    setMobileValue(value);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        mobile: value
      }
    });
  };

  const [countryCode, setSelectedCountryCode] = useState(null);
  const [selectedMemberCountry, setSelectedMemberCountry] = useState(null);

  //tradding countries
  const [targetCountryList, setTargetCountryList] = useState([]);
  const [target_country, setTagetCountry] = useState([]);

  const [address1, setAddress1] = useState("");
  const [pincode, setPincode] = useState("");

  const [countryList, setCountryList] = useState([]);
  const [memberCountryList, selectMemberCountryList] = useState([]);

  const [selectedMemberCity, setSelectedMemberCity] = useState(null);
  const [cityMemberList, setMemberCityList] = useState([]);

  const [yearOption, setYearOption] = useState([]);

  const [companyLogo, setCompanyLogo] = useState(null);
  const [certificateFile, setCertificateFile] = useState(null);

  const [errors, setErrors] = useState({});
  const [showSelectAll, setshowSelectAll] = useState(false);

  const option2 = { value: "all", label: "Select All" };

  const [certificateId, setCertificateId] = useState(null);
  const [companyLogoId, setCompanyLogoId] = useState(null);

  const [smallmodalShow, setSmallModalShow] = useState(false);

  const [selectSupplierTypes, setSelectSupplierTypes] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitTimeoutRef = useRef(null);

  const [mediummodalShow, setMediumModalShow] = useState(false);
  const [mediummodalShow2, setMediumModalShow2] = useState(false);

  const [docImagePath, setDocImagePath] = useState();
  const [docPdfPath, setDocPdfPath] = useState();
  
  const [certificateFileInputKey, setCertificateFileInputKey] = useState(0);
  const [logoFileInputKey, setLogoFileInputKey] = useState(0);

  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    return () => {
      if (submitTimeoutRef.current) clearTimeout(submitTimeoutRef.current);
    };
  }, []);


  useEffect(() => {
    if (props.supplierMember && Object.keys(props.supplierMember).length > 0) {
      const sm = props.supplierMember.step_1;
      console.log("********", sm);
        if(sm){
          setShowLoader(true);

          try {
            const fetchedData = {
          salutation: sm.salutation || "",
          first_name: sm.first_name || "",
          last_name: sm.last_name || "",
          email: sm.email || "",
          company_name: sm.company_name || "",
          website: sm.website || "",
          designation: sm.designation || "",
          phone: sm.phone || "",
          mobile: sm.mobile || "",
          country_id: sm.country_id || "",
          cities_id: sm.cities_id || "",
          city: sm.member_city,
        };

        // setFormData((prev) => ({
        //   ...prev,
        //   ...fetchedData,
        // }));
        setFormData(fetchedData);

        if (sm.phone) setPhoneValue(sm.phone);
        if (sm.mobile) setMobileValue(sm.mobile);

        const fetchedEstablishedYear = sm.establish_date;
        const selectedYearOption = yearOption.find(
          (option) => option.value == fetchedEstablishedYear
        );
        if (selectedYearOption) {
          setEstablishedYear(selectedYearOption);
        }

        const address = sm?.member_company_addresses || [];
        if (address[0]) {
          setAddress1(address[0].address1);
          setPincode(address[0].pincode);
        }

        const fetchedLogo = sm.company_logo;
        if (fetchedLogo == null) {
          setCompanyLogo("");
          setCompanyLogoId(null);
          setFormData((prevalue) => ({ ...prevalue, company_logo: "" }));
        } else {
          const logoUrl = IMAGE_PATH.BASE_URL + "/company_logo/" + fetchedLogo;
          setCompanyLogo(logoUrl);
          setCompanyLogoId(sm.id);
          setFormData((prevalue) => ({ ...prevalue, company_logo: fetchedLogo }));
        }

        const fetchedCertificate = sm.member_certificates?.[0];
        const certificateDetail = fetchedCertificate?.certificate_detail;
        if (!certificateDetail) {
          setCertificateFile(null);
          setCertificateId(null)
          setFormData((prevalue) => ({ ...prevalue, business_certificate: "" }));
        } else {
          const certUrl = PATH + "/member_certificates/" + certificateDetail;
          setCertificateFile(certUrl);
          setCertificateId(fetchedCertificate?.id)
          setFormData((prevalue) => ({ ...prevalue, business_certificate: certificateDetail }));
        }



        // let countryId = sm.country_id || sm.country;
        // let matchedCountry = null;

        // if (countryId && memberCountryList.length > 0) {
        //   matchedCountry = memberCountryList.find(
        //     (opt) => String(opt.value) === String(countryId)
        //   );
        // }

        // if (matchedCountry) {
        //   setSelectedMemberCountry(matchedCountry);
        //   setInputValue(matchedCountry.value);
        // }

        // if (!sm.member_city) {
        //   if (matchedCountry) {
        //     handleMemberCountryChange(matchedCountry, "", "", "fetch");
        //   }
        // } else if (sm.member_city.name) {
        //   if (sm.member_city.status === 0) {
        //     const existingCityOption = {
        //       value: sm.member_city.id,
        //       label: sm.member_city.name,
        //       name: sm.member_city.name,
        //     };
        //     setSelectedMemberCity(existingCityOption);
        //     setFormData((prev) => ({
        //       ...prev,
        //       cities_id: sm.member_city.id,
        //       isNewVal: false,
        //     }));
        //     if (matchedCountry) {
        //       fetchCityBasedOnCountry(matchedCountry.value, "", sm.cities_id || sm.city);
        //     }
        //   } else {
        //     if (matchedCountry) {
        //       handleMemberCountryChange(
        //         matchedCountry,
        //         sm.member_city.name,
        //         sm.cities_id,
        //         "fetch"
        //       );
        //     }
        //   }
        // }
         const selectedMemberCountryOption = memberCountryList.find(
          (option) => option.value == sm.country_id
        );
        setSelectedMemberCountry(selectedMemberCountryOption);
         if (sm.member_city == null) {
          handleMemberCountryChange(selectedMemberCountryOption, "", "", "fetch");
        } else if (sm.member_city.name) {
          handleMemberCountryChange(selectedMemberCountryOption, "", "", "fetch");
          if (sm.member_city.status === 0) {
            const options00 = {
              value: sm.member_city.id,
              label: sm.member_city.name,
              name: sm.member_city.name
            };
            setSelectedMemberCity(options00);
            setFormData((prevalue) => {
              return {
                ...prevalue,
                cities_id: sm.member_city.id,
                isNewVal: false
              }
            });
          } else {
            handleMemberCountryChange(selectedMemberCountryOption, sm.member_city.name, sm.cities_id, "fetch");
          }

        }


        if (sm && sm.trade_countries) {
          let targetCountry1 = [];
          sm.trade_countries.map((tradeCountries, index) => {
            let targetCountry = targetCountryList.find((c) => c.value === tradeCountries.country_id);
            if (!isEmpty(targetCountry)) {
              targetCountry1.push(targetCountry);
            }

          });
          setTagetCountry(targetCountry1);
          if (size(targetCountry1) === size(targetCountryList)) {
            setshowSelectAll(false);
          } else {
            setshowSelectAll(true);
          }
          setTimeout(() => {
                if (!isEmpty(sm.trade_countries)) {
                  let target_Countries = map(targetCountry1, 'value');
                  setFormData((prevalue) => ({ ...prevalue, target_country: target_Countries }));
                }
              }, 2000);
            }
          } finally {
            setShowLoader(false);
          }
    }
    if (props.supplier_id) {
      setSupplierMemberID(props.supplier_id);
    }
 }
   
  }, [props.supplierMember, props.supplier_id, memberCountryList, targetCountryList]);

  const handleTargetCountryChange = (event) => {
    if (event && event.find(option => option.value === "all")) {

      setTagetCountry(targetCountryList.filter(option => option.value !== "all"));
      setshowSelectAll(false);
      let target_country = map(targetCountryList.filter(option => option.value !== "all"), 'value');

      setFormData((prevalue) => {
        return {
          ...prevalue,
          target_country: target_country,
        };
      });

    }
    else if (event && event.length === targetCountryList.length - 1) {
      setTagetCountry(event);
      setshowSelectAll(true);

      let target_country = map(event, 'value');
      setFormData((prevalue) => {
        return {
          ...prevalue,
          target_country: target_country,
        };
      });
    } else {
      setTagetCountry(event);
      let target_country = map(event, 'value');
      if (size(target_country) === size(targetCountryList)) {
        setshowSelectAll(false);
      } else {
        setshowSelectAll(true);
      }
      setFormData((prevalue) => {
        return {
          ...prevalue,
          target_country: target_country,
        };
      });
    }
  }


  const yearsList = () => {
    let thisYear = new Date().getFullYear();
    let allYears = [];
    for (let x = thisYear; x >= 1901; x--) {
      const optionsYear = {
        value: x,
        label: x,
      };
      allYears.push(optionsYear);
    }
    setYearOption(allYears);
  };

  const [established_year, setEstablishedYear] = useState(null);

  const handleSelectChangeEstablishedYear = (selectedOption) => {
    setEstablishedYear(selectedOption);
  };



  const handleMemberCountryChange = (cval, ctname = "", cid = "", call_action = "") => {
    // console.log("cval ===========", cval);
    if (cval) {
      setSelectedCountryCode(cval.countryCode);

      setMemberCityList([]);
      const countryId = cval.value;
      setInputValue(countryId);
      setSelectedMemberCountry(cval);
      setSelectedMemberCity(null);
      if (call_action === "") {
        setPhoneValue("");
        setMobileValue("");
        setFormData((prevalue) => {
          return {
            ...prevalue,
            country_id: countryId,
            phone: "",
            mobile: "",
            cities_id: null,
            isNewVal: false
          }
        });
      }


      if (isString(ctname)) {
        fetchCityBasedOnCountry(countryId, ctname, cid);
      } else {
        fetchCityBasedOnCountry(countryId, "", cid);
      }
    }


  }

    const handleMemberCityChange = (ctval) => {
    if (ctval != null) {
      const cityId = ctval.value;
      setSelectedMemberCity(ctval);
      setFormData((prevalue) => {
        return {
          ...prevalue,
          cities_id: cityId,
          isNewVal: ctval.__isNew__
        }
      });

    }

  }

    const handleInputChange = (newValue) => {
    if ((newValue === '' || newValue === null) && inputValue > 0) {
      setMemberCityList([]);
      fetchCityBasedOnCountry(inputValue);
    }
    if (newValue !== '' && inputValue > 0) {
      if (newValue.length >= 3) {
        setMemberCityList([]);
        fetchCityBasedOnCountry(inputValue, newValue);
      }
    }
  };



  



  // certificate and logo
  const handleCertificateChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!ALLOWED_CERTIFICATE_TYPES.includes(file.type)) {
      setErrors((prev) => ({ ...prev, business_certificate: "The file must be a file of type jpg, png, jpeg or pdf" }));
      e.target.value = ""; // reset input so same invalid file can be re-selected after fix
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      setErrors((prev) => ({ ...prev, business_certificate: FILE_SIZE_ERROR_MSG }));
      e.target.value = "";
      return;
    }

    setCertificateFile(file);
    setErrors((prev) => ({ ...prev, business_certificate: "" }));
  };
  const handleCompanyLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!ALLOWED_LOGO_TYPES.includes(file.type)) {
      setErrors((prev) => ({ ...prev, company_logo: "The file must be a file of type jpg, png or jpeg." }));
      e.target.value = "";
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      setErrors((prev) => ({ ...prev, company_logo: FILE_SIZE_ERROR_MSG }));
      e.target.value = "";
      return;
    }

    setCompanyLogo(file);
    setErrors((prev) => ({ ...prev, company_logo: "" }));
  };
  const handleRemoveCertificate = () => {
    setCertificateFile(null);
    setFormData((prevalue) => ({ ...prevalue, business_certificate: ""}));
    setErrors((prev) => ({ ...prev, business_certificate: "" }));
    setCertificateFileInputKey((prev) => prev + 1);
  };

  const handleRemoveLogo = () => {
    setCompanyLogo(null);
    setFormData((prevalue) => ({ ...prevalue, company_logo: "" }));
    setErrors((prev) => ({ ...prev, company_logo: "" }));
     setLogoFileInputKey((prev) => prev + 1);
  };
  // adresss line


  const fetchCountries = async () => {
    await props.getCountries()
      .then((response) => {
        if (response.status === true) {
          const options = response.data.map((country) => ({
            value: country.id,
            label: country.name,
            countryCode: country.iso2,
          }));
          setCountryList(options);
          selectMemberCountryList(options);
        }
      })
      .catch((err) => {
        console.log("Error =", err);
      });
  };

  useEffect(() => {
    fetchCountries();
    yearsList();
  }, []);





  const fetchCityBasedOnCountry = async (countryId, city_name = "", cid = 0) => {
    // console.log('cityBasedOnCountry------------------', countryId);
    if (isEmpty(city_name)) {
      await props.getCity(countryId)
        .then((response) => {
          if (response.status === true) {
            const options = response.data.map(ct => ({
              value: ct.id,
              label: ct.name + (ct.state_code ? ' (' + ct.state_code + ')' : ''),
              name: ct.name
            }));
            setMemberCityList(options);

            if (cid > 0) {
              const selectedMemberCityOption = options.find(
                (option) => option.value === cid
              );
              setSelectedMemberCity(selectedMemberCityOption);
            }
          }
        })
        .catch((err) => {
          console.log("Error =", err);
        });

    } else if (!isEmpty(city_name)) {
      await props.getCitySearch(city_name, countryId)
        .then((response) => {
          if (response.status === true) {
            const options = response.data.map(ct => ({
              value: ct.id,
              label: ct.name + (ct.state_code ? ' (' + ct.state_code + ')' : ''),
              name: ct.name
            }));
            setMemberCityList(options);

            if (cid > 0) {
              const selectedMemberCityOption = options.find(
                (option) => option.value === cid
              );
              setSelectedMemberCity(selectedMemberCityOption);
            }
          }
        })
        .catch((err) => {
          console.log("Error =", err);
        });

    }

  }

  const handleChange = (e) => {
    setFormData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSelutation = (e) => {
    setFormData((prevalue) => {
      return {
        ...prevalue,
        salutation: e.target.value
      }
    });
  };

  const fetchTargetCountry = async () => {
    await props.getCountries()
      .then((response) => {
        if (response.status === true) {
          const options = response.data.map((country) => ({
            value: country.id,
            label: country.name,
          }));
          setTargetCountryList(options);
        }
      })
      .catch((err) => {
        console.log("Error =", err);
      });
  };



  useEffect(() => {
    const fetchData = async () => {
      // await fetchCountries();
      await fetchTargetCountry();
    };
    fetchData();
  }, []);


  const isDuplicate = (inputValue) => {
    return cityMemberList.some((option) => {
      let tmpLabel = option.label;
      let tmpLabels = tmpLabel.split('(');
      tmpLabel = trim(tmpLabels[0]);
      return tmpLabel.toLowerCase() === inputValue.toLowerCase()
    })
  };

  const validateAddress1 = (value) => {
    if (!value) return "";
    if (value.length > ADDRESS1_MAX_LENGTH) {
      return `The field must not be greater than 255 characters.`;
    }
    return "";
  };

  const validatePincode = (value) => {
    if (!value) return "";
   
    if (value.length > PINCODE_MAX_LENGTH) {
      return `The field must not be greater than 10 characters.`;
    }
     const regEx = regExpressions.pincode;
    const isValid = regEx.test(value);
    if (!isValid) {
        return errorMessages.IN_VALID_FIELD_FORMAT;
    } 


    return "";
  };

  const validation = () => {

    let er = {};
   
    if (!formData.first_name) {
      er.first_name = errorMessages.FIELD_REQUIRED;
    } else if (formData.first_name.length > 40) {
      er.first_name = errorMessages.MAX_LENGTH_EXCEEDED;
    } else if (!regExpressions.name.test(formData.first_name)) {
      er.first_name = errorMessages.IN_VALID_FIELD_FORMAT;
    }

    // Last Name (optional)
    if (formData.last_name) {
      if (formData.last_name.length > 40) {
        er.last_name = errorMessages.MAX_LENGTH_EXCEEDED;
      } else if (!regExpressions.name.test(formData.last_name)) {
        er.last_name = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    // Designation (required)
    if (!formData.designation) {
      er.designation = errorMessages.FIELD_REQUIRED;
    } else if (formData.designation.length > 100) {
      er.designation = errorMessages.MAX_LENGTH_100_EXCEEDED;
    } else if (!DESIGNATION_REGEXP.test(formData.designation)) {
      er.designation = errorMessages.IN_VALID_FIELD_FORMAT;
    }

    // Company Name (required)
    if (!formData.company_name) {
      er.company_name = errorMessages.FIELD_REQUIRED;
    } else if (formData.company_name.length > 150) {
      er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else if (!regExpressions.company_name.test(formData.company_name)) {
      er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
    }

    // Country (required)
    if (!formData.country_id) {
      er.country_id = errorMessages.FIELD_REQUIRED;
    }

    // Established Year (required)
    if (!established_year || !established_year.value) {
      er.est_year = errorMessages.FIELD_REQUIRED;
    }

    if (phoneValue === undefined || !phoneValue || !isValidPhoneNumber(phoneValue)) {
      if (phoneValue == null || phoneValue === '') {
        er.phone = errorMessages.FIELD_REQUIRED;
      } else {
        let numberWithoutCountryCode = phoneValue.replace(/^\+(\d{1,4})\s?/, '');
        numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, '');
        if (phoneValue === undefined || phoneValue === "" && numberWithoutCountryCode.length == 0) {
          er.phone = errorMessages.FIELD_REQUIRED;
        } else {
          if (numberWithoutCountryCode.length > 0) {
            er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
          }
        }
      }

    } 


    if (mobileValue) {
      let numberWithoutCountryCode = mobileValue.replace(/^\+(\d{1,4})\s?/, '');
      numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, '');
      if (!mobileValue || !isValidPhoneNumber(mobileValue) && numberWithoutCountryCode.length > 0) {
        er.mobile = errorMessages.MOBILE_NUMBER_VALIDATION_MSG;
      } 
    }

    if (mobileValue && phoneValue) {
      if (mobileValue === phoneValue) {
        er.mobile = errorMessages.UNIQUE_MSG;
      }
      // if (mobileValue !== phoneValue && isValidPhoneNumber(mobileValue)) {
      //   er.mobile = '';
      // }
    }

    if (formData.website) {
      if (formData.website.length > 255) {
        er.website = errorMessages.MAX_LENGTH_255_EXCEEDED;
      } else if (!WEBSITE_REGEXP.test(formData.website)) {
        er.website = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    // Address (optional, length-limited)
    const address1Error = validateAddress1(address1);
    if (address1Error) {
      er.address1 = address1Error;
    }

    // Pincode (optional, format-limited)
    const pincodeError = validatePincode(pincode);
    if (pincodeError) {
      er.pincode = pincodeError;
    }

    if (target_country === null || isEmpty(target_country) && target_country.length === 0) {
      er.trading_countries = errorMessages.FIELD_REQUIRED;
    }


     if (!certificateFile && !formData.business_certificate) {
      er.business_certificate = errorMessages.FIELD_REQUIRED;
    } else if (isNewFileValue(certificateFile) && certificateFile.size > MAX_FILE_SIZE) {
      er.business_certificate = FILE_SIZE_ERROR_MSG;
    }

    // Company Logo (optional)
    if (isNewFileValue(companyLogo) && companyLogo.size > MAX_FILE_SIZE) {
      er.company_logo = FILE_SIZE_ERROR_MSG;
    }

    setErrors(er);

    // Valid only if every field in `er` is empty/falsy.
    return Object.values(er).every((msg) => !msg);

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
   
    setErrors({});

    let isValidCompanyInfo = await validation();
    if (!isValidCompanyInfo) {
      return;
    } 

    const businessCertificatePayload = isNewFileValue(certificateFile) ? certificateFile : null;
    const companyLogoPayload = isNewFileValue(companyLogo) ? companyLogo : null;

    const submissionData = {
      ...formData,
      phone: phoneValue,
      mobile: mobileValue,
    };

    delete submissionData.business_certificate;
    delete submissionData.company_logo;

    setIsSubmitting(true);
    setShowLoader(true);
    await props
      .updateSupplierCompany(
        member_supplier_id,
        submissionData,
        established_year?.value,
        map(target_country, 'value'),
        address1,
        pincode,
        businessCertificatePayload,
        companyLogoPayload
      )
      .then((response) => {
        if (response === true) {
          props.onSupplierUpdated();
          props.onNext();
          return;
        }

        let er = { ...errors };
        if (response?.message === "Validation Errors") {
          setErrors({});
          if (response.error.first_name) {
            er.first_name = response.error.first_name;
          } else {
            er.first_name = '';
          }

          if (response.error.mobile) {
            er.mobile = response.error.mobile;
          } else {
            er.mobile = '';
          }
          if (response.error.phone) {
            er.phone = response.error.phone;
          } else {
            er.phone = '';
          }
          if (response.error.designation) {
            er.designation = response.error.designation;
          } else {
            er.designation = '';
          }
          if (response.error.company_name) {
            er.company_name = response.error.company_name;
          } else {
            er.company_name = '';
          }

          if (response.error.est_year) {
            er.est_year = response.error.est_year;
          } else {
            er.est_year = '';
          }

          if (response.error.trading_countries) {
            er.trading_countries = response.error.trading_countries;
          } else {
            er.trading_countries = '';
          }
          if (response.error.business_certificate) {
            er.business_certificate = response.error.business_certificate;
          } else {
            er.business_certificate = '';
          }


          if (response.error.company_logo) {
            er.company_logo = response.error.company_logo;
          } else {
            er.company_logo = '';
          }

          if (response.error.website) {
            er.website = response.error.website;
          } else {
            er.website = '';
          }

          setErrors(er);
          return Object.keys(er).length > 0;
        }

      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {
        setIsSubmitting(false);
        setShowLoader(false);
        submitTimeoutRef.current = setTimeout(() => {
          setIsSubmitting(false);
        }, 600);
      });

     

  }

  const CustomOption = ({ innerRef, innerProps, isSelected, label }) => (

    <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }} className={isSelected ? "div-item-selected" : "div-item-unselected"} >
      {/* <input type="checkbox" checked={isSelected} readOnly /> */}
      {isSelected && <div className={` item-selected `}><label style={{ marginLeft: '8px' }}>{label}</label></div>}
      {!isSelected && <div className={` item-selected2 `}><label style={{ marginLeft: '8px' }}>{label}</label></div>}

    </div>

  );

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      '&:hover': {
      },
    }),
     valueContainer: (provided) => ({
     ...provided,
      display: 'flex',
      flexWrap: 'nowrap',
      overflow: 'hidden',
      alignItems: 'center',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#4c9bdb', // Background of the selected multi-value items
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#fff', // Color of the text inside the multi-value
      fontSize: "12px"
    }),

    multiValueRemove: (provided) => ({
      ...provided,
      color: '#fff', // Remove button color
      ':hover': {
        backgroundColor: '#df0024', // Background color on hover for the remove button
      },
    }),
  };

  const MoreSelectedBadge = ({ items }) => {
    const style = {
       marginLeft: "4px",
      background: "#d4eefa",
      borderRadius: "4px",
      fontFamily: "Open Sans",
      fontSize: "11px",
      padding: "3px",
      // order: 99,
      whiteSpace: "nowrap",
      flexShrink:0
    };

    const title = items.join(", ");
    const length = items.length;
    const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;

    return (
      <div style={style} title={title}>
        {label}
      </div>
    );
  };

  const MultiValue = ({ index, getValue, ...props }) => {
    const maxToShow = 1;
    const overflow = getValue()
      .slice(maxToShow)
      .map((x) => x.label);

    return index < maxToShow ? (
      <components.MultiValue {...props} />
    ) : index === maxToShow ? (
      <MoreSelectedBadge items={overflow} />
    ) : null;
  };

  const styleError = {
    display: 'block',
  };

  const logoSrc = getPreviewSrc(companyLogo);
  const certSrc = getPreviewSrc(certificateFile);

  const hasCustomLogo = Boolean(companyLogo) && companyLogo !== "";
  const certIsPdf = isPdfValue(certificateFile);


  const handleRemoveFile = (type, id) => {
    setSmallModalShow(true);
    setSelectSupplierTypes(type)
  }

  const handleConfirmDeleteClick = async () => {
    try {
      const stepper = 'stepper';
      if (selectSupplierTypes === 'certificate') {
        const response = await props.deleteSupplierCertificate(
          certificateId,stepper
        );

        if (response?.status !== true) {
          console.log(
            response?.message || "Unable to delete certificate"
          );
          return;
        }

        setCertificateFile(null);
        setCertificateId(null);

        setFormData((prev) => ({
          ...prev,
          business_certificate: "",
        }));

        setSmallModalShow(false);
        // await props.onSupplierUpdated();
      }

      if (selectSupplierTypes === 'logo') {
        const response = await props.deleteSupplierLog(
          companyLogoId
        );

        if (response?.status !== true) {
          console.log(
            response?.message || "Unable to delete certificate"
          );
          return;
        }

        setCompanyLogo(null);
        setCompanyLogoId(null);

        setFormData((prev) => ({
          ...prev,
          company_logo: "",
        }));

        setSmallModalShow(false);
        // await props.onSupplierUpdated();
      }



    } catch (err) {
      console.log("Error == ", err);
    }
  };

  const handleFocusOut = async (e) => {
    let flag = 0;
    let er = { ...errors };
    if (e.target.name === 'first_name') {
      if (e.target.value === '') {
        flag = 1;
        er.first_name = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 40) {
        flag = 1;
        er.first_name = errorMessages.MAX_LENGTH_EXCEEDED;
      } else {
        const regExp = regExpressions.name;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.first_name = errorMessages.IN_VALID_FIELD_FORMAT;
        }
        else {
          flag = 0;
          er.first_name = '';
        }
      }
    }

    if (e.target.name === 'last_name') {
      if (e.target.value !== '') {
        if (e.target.value.length > 40) {
          flag = 1;
          er.last_name = errorMessages.MAX_LENGTH_EXCEEDED;
        }
        else {
          const regExp = regExpressions.name;
          const check = regExp.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.last_name = errorMessages.IN_VALID_FIELD_FORMAT;
          }
          else {
            flag = 0;
            er.last_name = '';
          }
        }
      } else {
        flag = 0;
        er.last_name = '';
      }
    }


    if (e.target.name === 'designation') {
      if (e.target.value === '') {
        flag = 1;
        er.designation = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 100) {
        flag = 1;
        er.designation = errorMessages.MAX_LENGTH_100_EXCEEDED;
      } else {
        const regExp = /^[A-Za-z](?:[A-Za-z0-9 ,&.-/]*[A-Za-z0-9])?(?:\s*[-&/]\s*[A-Za-z0-9]+)*(?:\s*)?$/;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.designation = errorMessages.IN_VALID_FIELD_FORMAT;
        }
        else {
          flag = 0;
          er.designation = '';
        }
      }
    }

    if (e.target.name === 'phone') {
      let phoneValue = e.target.value;
      let numberWithoutCountryCode = phoneValue.replace(/^\+(\d{1,4})\s?/, '');
      numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, '');
      if (phoneValue === undefined || !phoneValue || !isValidPhoneNumber(phoneValue)) {
        if (phoneValue === undefined || phoneValue === "") {
          flag = 1;
          er.phone = errorMessages.FIELD_REQUIRED;
        } else {
          if (numberWithoutCountryCode.length > 0) {
            flag = 1;
            er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
          } else {
            flag = 0;
            er.phone = '';
          }
        }

      } else {
        flag = 0;
        er.phone = '';

      }

    }
    if (e.target.name === 'mobile') {
      let mobileValue = e.target.value;
      let numberWithoutCountryCode = mobileValue.replace(/^\+(\d{1,4})\s?/, '');
      numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, '');

      if (mobileValue) {
        if (!mobileValue || !isValidPhoneNumber(mobileValue) && numberWithoutCountryCode.length > 0) {
          flag = 1;
          er.mobile = errorMessages.MOBILE_NUMBER_VALIDATION_MSG;
        } else {
          flag = 0;
          er.mobile = '';

        }
        let mobileNo = mobileValue.replace(/ /g, '');
        if (mobileNo === phoneValue) {
          flag = 1;
          er.mobile = errorMessages.UNIQUE_MSG;
        }
      }

    }

    if (e.target.name === 'company_name') {
      if (e.target.value === '') {
        flag = 1;
        er.company_name = errorMessages.FIELD_REQUIRED;
      }
      else if (e.target.value.length > 150) {
        flag = 1;
        er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const regExp = regExpressions.company_name;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
        }

        else {
          flag = 0;
          er.company_name = '';
        }
      }
    }

    if (e.target.name === 'website') {
      if (e.target.value !== '') {
        if (e.target.value.length > 255) {
          flag = 1;
          er.website = errorMessages.MAX_LENGTH_255_EXCEEDED;
        } else {
          const regExp = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;
          const check = regExp.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.website = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.website = '';
          }
        }
      } else {
        flag = 0;
        er.website = '';
      }
    }


     if (e.target.name === 'address1') {
      const addressError = validateAddress1(e.target.value);
      if (addressError) {
        flag = 1;
        er.address1 = addressError;
      } else {
        flag = 0;
        er.address1 = '';
      }
    }

    if (e.target.name === 'pincode') {
      const pincodeErr = validatePincode(e.target.value);
      if (pincodeErr) {
        flag = 1;
        er.pincode = pincodeErr;
      } else {
        flag = 0;
        er.pincode = '';
      }
    }

    setErrors(er);
    if (flag === 0) {
      return false;
    } else {
      return true;
    }


  }

  const handleYearBlur = () => {
    const errors = validateEstablishedDate(established_year);
    setErrors(prev => ({
      ...prev,
      est_year: errors.established_year || '',
    }));
  };

  const validateEstablishedDate = (year = established_year) => {
    let errors = {};
    if (!year) {
      errors.est_year = "The field is required.";
    }

    return errors;
  };



  const style2 = {
    height: '50px',
    width: '50px',
  };

  const style3 = {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  };

  const handleImageShow = (path) => {
    if (!path) return;
    setDocImagePath(path);
    setMediumModalShow(true);
  }

  const handlePdfShow = (path) => {
    if (!path) return;
    setDocPdfPath(path);
    setMediumModalShow2(true);
  }

    const handleAddress1Change = (e) => {
    setAddress1(e.target.value);
    if (errors.address1) {
      setErrors((prev) => ({ ...prev, address1: "" }));
    }
  };

  const handlePincodeChange = (e) => {
    setPincode(e.target.value);
    if (errors.pincode) {
      setErrors((prev) => ({ ...prev, pincode: "" }));
    }
  };

  return (
    <>
       {showLoader && <ScreenLoaderHome />}
      <form onSubmit={handleSubmit} className='stepper-form'>

        <div className='basic-details-wrape'>

          <div className='section-header'>
            <h2>Unlock Global Buyer Opportunities</h2>
            <p>
              Tell us about your company so buyers can discover, evaluate and connect with your business.
            </p>
          </div>
          <div className='row update-profile-wrapper'>

            <div className='col-md-6 col-xl-4 py-2'>
              <label className='profile-text'>First Name<span className='text-danger'>{' '}*</span></label>

              <div className="d-flex">

                <span className={`input-group-addon`}>
                  <select name="salutation" onChange={handleSelutation} value={formData.salutation}>
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Miss">Miss</option>
                  </select>

                </span>

                <div className="w-100">
                  <InputField
                    onChange={handleChange}
                    placeholder={"Enter your first name"}
                    className={"input-error-border mr-input"}
                    value={formData.first_name}
                    name="first_name"
                    onBlur={handleFocusOut}
                    autoComplete="off"
                  ></InputField>

                </div>

              </div>
              {errors.first_name && <span className="company-required" style={styleError}>{errors.first_name}</span>}
            </div>


            <div className='col-md-6 col-xl-4 py-2'>
              <label className='profile-text'>Last Name</label>

              <InputField
                placeholder={"Enter your last name"}
                className={"input-error-border"}
                value={formData.last_name}
                onChange={handleChange}
                name="last_name"
                onBlur={handleFocusOut}
                autoComplete="off"
              >
              </InputField>
              {errors.last_name && <span className="company-required" style={styleError}>{errors.last_name}</span>}
            </div>
            <div className='col-md-6 col-xl-4 py-2'>
              <label className='profile-text'>Designation<span className='text-danger'>{' '}*</span>
              </label>

              <InputField
                placeholder={"Enter your designation"}
                className={"input-error-border"}
                value={formData.designation}
                onChange={handleChange}
                name="designation"
                onBlur={handleFocusOut}
                autoComplete="off"

              >
              </InputField>
              {errors.designation && <span className="company-required" style={styleError}>{errors.designation}</span>}
            </div>


            <div className='col-md-6 col-xl-4 py-2'>

              <label className='profile-text'>Email Address
                <span className='text-danger'>{' '}*</span>
              </label>

              <InputField
                placeholder={" Enter your email"}
                className={"input-error-border"}
                value={formData.email}
                // onChange={handleChange}
                name="email"
                // onBlur={handleFocusOut}
                disabled={'true'}
                autoComplete="off"
              >
              </InputField>


            </div>

            <div className='col-md-6 col-xl-4 py-2'>
              <label className='profile-text'>Contact
                <span className='text-danger'>{' '}*</span>
              </label>
              <PhoneInput id="contact-form-phone" name="phone"
                international limitMaxLength
                placeholder="Enter contact"
                defaultCountry={countryCode}
                value={phoneValue}
                onChange={handlePhoneChange}
                onBlur={handleFocusOut}
                className="input-error-border"
                autoComplete="off"
                countryCallingCodeEditable={false}
              />
               {errors.phone && <span className="company-required" style={styleError}>{errors.phone}</span>}
            </div>


            <div className='col-md-6 col-xl-4 py-2'>
              <label className='profile-text'>Mobile</label>
              <PhoneInput
                id="contact-form-mobile"
                name="mobile"
                international
                limitMaxLength
                placeholder="Enter mobile"
                defaultCountry={countryCode}
                value={mobileValue}
                onChange={handleMobileChange}
                onBlur={handleFocusOut}
                className="input-error-border"
                autoComplete="off"
              // countryCallingCodeEditable={true}
              // onKeyDown={handleKeyDown}
              />
              {errors.mobile && <span className="company-required" style={styleError}>{errors.mobile}</span>}
            </div>

            <div className='col-md-6 col-xl-4 py-2'>
              <label className='profile-text'>Company Name
                <span className='text-danger'>{' '}*</span>

              </label>

              <InputField
                placeholder={"Enter your company name"}
                className={"input-error-border"}
                value={formData.company_name}
                onChange={handleChange}
                name="company_name"
                onBlur={handleFocusOut}
                // disabled={props.disableProfile || isViewer}
                autoComplete="off"
              >
              </InputField>
              {errors.company_name && <span className="company-required" style={styleError}>{errors.company_name}</span>}

            </div>

            <div className='col-md-6 col-xl-4 py-2'>
              <label className='profile-text'>Website</label>
              <InputField
                placeholder={"Enter your website url"}
                className={"input-error-border"}
                value={formData.website}
                onChange={handleChange}
                name="website"
                onBlur={handleFocusOut}
                // disabled={props.disableProfile || isViewer}
                autoComplete="off"
              >
              </InputField>

              {errors.website && <span className="company-required" style={styleError}>{errors.website}</span>}

            </div>

            <div className='col-md-6 col-xl-4 py-2'>

              <label className='profile-text'>Trading Country
                <span className='text-danger'>{' '}*</span>
              </label>

              <ReactSelect
                // options={showSelectAll ? [option2, ...targetCountryList] : targetCountryList}
                options={targetCountryList}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={true}
                components={{ Option: CustomOption, IndicatorSeparator: () => null, MultiValue }}
                removeSelected={false}
                name="target_country"
                value={target_country}
                classNamePrefix="react-select"
                onChange={handleTargetCountryChange}
                styles={customStyles}
                // components={{ Option: CustomOption }}
                noOptionsMessage={() => "No Country Found"}
                className="drop-down-multi"
              />
              {errors.trading_countries && <span className="company-required" style={styleError}>{errors.trading_countries}</span>}
            </div>

            <div className='col-md-6 col-xl-4 py-2'>
              <label className='profile-text'>Established Year
                <span className='text-danger'>{' '}*</span>
              </label>
              <DropDown
                placeholder={"Select year"}
                className={"input-error-border"}
                options={yearOption}
                value={established_year}
                onChange={handleSelectChangeEstablishedYear}
                onBlur={handleYearBlur}
                name="established_year"
                noOptionsMessage={() => "No Year Found"}

              ></DropDown>
              {errors.est_year && <span className="company-required" style={styleError}>{errors.est_year}</span>}

            </div>

            <div className='col-md-6 col-xl-4 py-2'>

              <label className='profile-text'>Country
                <span className='text-danger'>{' '}*</span>
              </label>
              <DropDown
                placeholder={"Select country"}
                className={"input-error-border"}
                options={memberCountryList}
                value={selectedMemberCountry}
                onChange={handleMemberCountryChange}
                menuPlacement={"bottom"}
              // isDisabled={props.disableProfile || isViewer}
              ></DropDown>
              {errors.country_id && <span className="company-required" style={styleError}>{errors.country_id}</span>}
            </div>

            <div className='col-md-6 col-xl-4 py-2'>

              <label className='profile-text'>City
              </label>
              <CreatableSelect
                onChange={handleMemberCityChange}
                onInputChange={handleInputChange}
                options={cityMemberList}
                value={selectedMemberCity}
                classNamePrefix={"creatable_react_select"}
                placeholder="Enter city"
                formatCreateLabel={(inputValue) =>
                  isDuplicate(inputValue) ? null : `Create "${inputValue}"`
                }
                isValidNewOption={(inputValue) => !isDuplicate(inputValue)}

              />
              {errors.cities_id && <span className="company-required" style={styleError}>{errors.cities_id}</span>}
            </div>


          </div>
          <div className="text-end d-flex justify-content-between align-items-center border-bottom mt-4"></div>
          <div className="row mt-2">


            <div className="upload-content py-2">
              <div className="upload-input">

                <h4 className="upload-text">
                  Business Certificate <span className="text-danger">*</span>
                </h4>

                <Choosefile
                  key={`${certificateFileInputKey}`}
                  className="form-control choose-pdf"
                  type="file"
                  accept="image/jpeg,image/png,image/jpg,application/pdf"
                  onChange={handleCertificateChange}
                  name="certificate"
                  id="certificate"
                />
                 {errors.business_certificate && <span className="company-required" style={styleError}>{errors.business_certificate}</span>}
                <p className="upload-info">
                  Allowed PDF, JPEG, JPG or PNG. Max size of 2 MB
                </p>
               
              </div>

              <div className="upload-img">
                <div className="position-relative certificate-img-hover">


                  {certificateFile && (
                    certIsPdf ? (
                      <img
                        src={pdf}
                        alt="PDF Icon"
                        style={style2}
                        id="cert-pdf-img"
                        onClick={() => handlePdfShow(certSrc)}
                      />
                    ) : (
                      <img
                        src={certSrc}
                        alt="Business certificate preview"
                        style={style2}
                        id="cert-img"
                        onClick={() => handleImageShow(certSrc)}
                      />
                    )
                  )}



                  {certificateFile && certificateId == null && (
                    <button
                      type="button"
                      className="pdf-close"
                      onClick={handleRemoveCertificate}
                    >
                      <i className="fa-regular fa-trash-can text-danger"></i>
                    </button>
                  )}

                  {certificateFile && certificateId !== null && (
                    <button
                      type="button"
                      className="pdf-close"
                      onClick={() => handleRemoveFile("certificate", certificateId)}
                    >
                      <i className="fa-regular fa-trash-can text-danger"></i>
                    </button>
                  )}


                </div>
              </div>
            </div>


            <div className="upload-content py-2">
              <div className="upload-input">

                <h4 className="upload-text">
                  Company Logo
                </h4>

                <Choosefile
                  key={`${logoFileInputKey}`}
                  className="form-control choose-pdf"
                  type="file"
                  accept="image/jpeg,image/png,image/jpg"
                  onChange={handleCompanyLogoChange}
                  name="companyLogo"
                  id="companyLogo"
                />
                {errors.company_logo && <span className="company-required" style={styleError}>{errors.company_logo}</span>}
                <p className="upload-info">
                  Allowed JPEG, JPG or PNG. Max size of 2 MB
                </p>
                
              </div>

              <div className="upload-img">
                <div className="position-relative certificate-img-hover">

                  {logoSrc && (
                    <img
                      src={logoSrc}
                      alt="Company Logo"
                    />
                  )}


                  {hasCustomLogo && companyLogoId == null && (
                    <button
                      type="button"
                      className="pdf-close"
                      onClick={handleRemoveLogo}
                    >
                      <i className="fa-regular fa-trash-can text-danger"></i>
                    </button>
                  )}

                  {hasCustomLogo && companyLogoId !== null && (
                    <button
                      type="button"
                      className="pdf-close"
                      onClick={() => handleRemoveFile("logo", companyLogoId)}
                    >
                      <i className="fa-regular fa-trash-can text-danger"></i>
                    </button>
                  )}

                </div>
              </div>
            </div>

          </div>

          <div className='row mb-4'>
            <div className='col-xl-6 py-2'>
              <label className='profile-text'>Address
              </label>
              <InputField
                className={"input-error-border"}
                value={address1}
                onChange={handleAddress1Change}
                onBlur={handleFocusOut}
                placeholder={"Enter address"}
                name="address1"
                maxLength={ADDRESS1_MAX_LENGTH}
                autoComplete="off"
              />
              {errors.address1 && (
                <span className="company-required" style={styleError}>
                  {errors.address1}
                </span>
              )}

            </div>

            <div className='col-xl-6 py-2'>
              <label className='profile-text'>Postal code
              </label>
              <InputField
                className={"input-error-border"}
                value={pincode}
                onChange={handlePincodeChange}
                onBlur={handleFocusOut}
                name="pincode"
                placeholder={"Enter postal code"}
                maxLength={PINCODE_MAX_LENGTH}
                autoComplete="off"
              />
              {errors.pincode && (
                <span className="company-required" style={styleError}>
                  {errors.pincode}
                </span>
              )}

            </div>
          </div>

          <div className='profile-button border-top'>
            {/* <ButtonAdminpanel className="mt-3 " type="submit" onClick={props.onNext} >
                        Continue
                      </ButtonAdminpanel>  */}
            <ButtonAdminpanel className="mt-3 " type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Continue to Add Products" : "Continue to Add Products"}
            </ButtonAdminpanel>
          </div>

        </div>
      </form>

      <SmallPopup
        title={`Delete ${selectSupplierTypes}`}
        smallmodalShow={smallmodalShow}
        setSmallModalShow={setSmallModalShow}
        onSubmit={handleConfirmDeleteClick}
        closeButtonLabel="Cancel"
        okButtonLabel="Delete"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0">Are you sure you want to delete?</div>
        </div>
      </SmallPopup>

      <MediumPopup
        title="Certificate"
        mediummodalShow={mediummodalShow}
        setMediumModalShow={setMediumModalShow}
        closeButtonLabel="Cancel"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0">
            <img src={docImagePath} alt="Placeholder" style={style3} id="doc-preview-img" />
          </div>
        </div>
      </MediumPopup>

      <MediumPopup
        title="Certificate"
        mediummodalShow={mediummodalShow2}
        setMediumModalShow={setMediumModalShow2}
        closeButtonLabel="Cancel"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0" style={{ height: "500px" }}>
            <embed src={`${docPdfPath}#toolbar=0`} type='application/pdf' style={style3} id="doc-preview-pdf" />
          </div>
        </div>
      </MediumPopup>

    </>
  )
}

const mapStateToProps = (state) => {
  return {

  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateSupplierCompany: (
      member_id,
      formData,
      established_year,
      target_country,
      address1,
      pincode,
      certificateFile,
      companyLogo
    ) =>
      dispatch(
        updateSupplierCompanyAction(
          member_id,
          formData,
          established_year,
          target_country,
          address1,
          pincode,
          certificateFile,
          companyLogo
        )
      ),
    getCountries: () => dispatch(countryList()),
    getCity: (countryId) => dispatch(cityMemberList(countryId)),
    getCitySearch: (city_name, countryId) => dispatch(citySearchMemberList(city_name, countryId)),
    deleteSupplierCertificate: (cetificateId,stepper) => dispatch(deleteCertificate(cetificateId,stepper)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
    deleteSupplierLog: (logoId) => dispatch(removeSupplierLogo(logoId)),
    

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BasicDetails);


